<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Dashboard content
      </div>
      <div v-if="menu" class="card-block">
        <div class="list-group">
          <router-link
            v-for="item in menu"
            :item="item"
            :key="item.name"
            :to="{path:`${item.url}`}"
            class="list-group-item list-group-item-action"
          >
            <i :class="item.icon" /> {{ item.name }}
          </router-link>
        </div>
      </div>
      <div v-else class="card-block">
        Content is empty for current user.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { menu } from '../helpers/menu';

export default {
  name: 'Dashboard',

  data: () => ({
    menu: null
  }),
  computed: {
    ...mapGetters('user', {
      userPermissions: 'getPermissions',
    }),
  },
  mounted() {
    this.menu = this.filterMenuItemsByUserPermissions(menu, this.userPermissions);
  },
  methods: {
    filterMenuItemsByUserPermissions(menuItems, permissions) {
      return menuItems.filter((menuItem) => {
        const { permissions: itemPermissions } = menuItem;
        const userRights = permissions.map(item => item.id);
        if (!itemPermissions) {
          return true;
        }
        return itemPermissions.reduce((hasPermission, perm) => userRights.includes(perm) || hasPermission, false);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Dashboard.vue?2d2721d4